import React from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Divider,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import InternalNoteContent from "./InternalNoteContent";

const formatDate = (value) => {
  if (!value) return "";
  const mysql = String(value).match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}:\d{2}:\d{2})/);
  if (mysql) return `${mysql[3]}/${mysql[2]}/${mysql[1]} ${mysql[4]}`;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleString();
};

const InternalNoteHistoryDialog = ({ open, onClose, message, authorLabel }) => {
  const { t } = useTranslation("chat");
  const history = Array.isArray(message?.editHistory) ? message.editHistory : [];
  const deleted = Boolean(message?.deletedAt);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {deleted
          ? t("messages.deletedNoteTitle", "Anotação excluída")
          : t("messages.noteHistoryTitle", "Histórico da anotação")}
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          {deleted
            ? t("messages.deletedNoteContent", "Conteúdo excluído")
            : t("messages.currentNoteVersion", "Versão atual")}
        </Typography>
        <Box sx={{ p: 1.5, borderRadius: 1, bgcolor: "action.hover" }}>
          <InternalNoteContent text={message?.text || ""} authorLabel={authorLabel} />
        </Box>

        {history.length > 0 && (
          <>
            <Divider sx={{ my: 2 }} />
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              {t("messages.previousNoteVersions", "Versões anteriores")}
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              {[...history].reverse().map((entry, index) => (
                <Box key={`${entry.savedAt || "version"}-${index}`}>
                  {entry.savedAt && (
                    <Typography variant="caption" color="text.secondary">
                      {formatDate(entry.savedAt)}
                    </Typography>
                  )}
                  <Box sx={{ mt: 0.5, p: 1.5, border: "1px solid", borderColor: "divider", borderRadius: 1 }}>
                    <InternalNoteContent text={entry.content || ""} authorLabel={authorLabel} />
                  </Box>
                </Box>
              ))}
            </Box>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("messages.close", "Fechar")}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default InternalNoteHistoryDialog;
